import React from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import MomentUtils from '@date-io/moment';
import { Provider as StoreProvider } from 'react-redux';
import { ThemeProvider } from '@material-ui/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { renderRoutes } from 'react-router-config';

import theme from './theme';
import { configureStore } from './store';
import routes from './routes';
import {
  ScrollReset,
  GoogleAnalytics,
  CookiesNotification
} from './components';
import './mixins/chartjs';
import './mixins/moment';
import './mixins/validate';
import './mixins/prismjs';
import './mock';
import './assets/scss/index.scss';


// const history = createBrowserHistory();
const store = configureStore();

const rawBasename =
  (process.env.REACT_APP_BASENAME && process.env.REACT_APP_BASENAME.trim()) || '';
const history = createBrowserHistory({
  basename: rawBasename || undefined
});

const App = () => {
  return (

    <StoreProvider store={store}>
      <ThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          {/* <Router basename={'/bellizadesignerstudio.com/'} history={history}> */}
           <Router
            basename={rawBasename || undefined}
            history={history}
          >
            <ScrollReset />
            <GoogleAnalytics />   
            <CookiesNotification />
            {renderRoutes(routes)}
          </Router>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </StoreProvider>
  );
};

export default App;
